import { IonPage, IonContent, IonHeader } from "@ionic/react";
import { Business, Search } from "@mui/icons-material";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Skeleton,
  TextField,
  InputAdornment,
} from "@mui/material";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import GenerateCodeModal from "../../components/generate-code-modal";
import GenerateCodeTable from "../../components/generate-code-table";
import styles from "./ManageStaff.module.css";
import { useBusinessContext } from "../../context/business-context";
import StaffModal from "../../components/staffs/manage-staff-modal";
import StaffsTable from "../../components/staffs/staffs-table";
import { baseUrl, config, requestID } from "../../common/utils";
import axios from "axios";
import AlertDialog from "../../components/dialog";
import { useHistory } from "react-router";
// import AlertDialog from "../../components/dialog";

const ManageStaff = () => {
  const {
    selectedBusinessId,
    setSelectedBusinessId,
    selectedBusinessTypeId,
    setSelectedBusinessTypeId,
    selectedBusinessName,
    setSelectedBusinessName,
    selectedBusinessTypeName,
    setSelectedBusinessTypeName,
    selectedRoleID,
    setSelectedRoleID,
    selectedRoleName,
    selectedBusiness
  } = useBusinessContext();
  // const { selectedBusinessId } = useBusinessContext();
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [activatationList, setActivatationList] = useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [selectedStaff, setSelectedStaff] = React.useState(null);
const [banklist, setBankList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const history = useHistory();


   const getBanklist = async () => {
    // try {
    setStatus({ loading: true, error: false });
    const formData = new FormData();
    formData.append("requestID", requestID());
   

    console.log(formData);
    const response = await axios.post(
      baseUrl() + "settings/getBanklist",
      formData,
      config
    );
    console.log({ response });
    const data = await response.data.data;
    setBankList(data);
    setStatus({ loading: false, error: false });
  };



  const getRoles = async () => {
    // try {
    setStatus({ loading: true, error: false });
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusinessId);
    formData.append("business_type", selectedBusiness.business_type_id);
    

    console.log(formData);
    const response = await axios.post(
      baseUrl() + "settings/getRoles",
      formData,
      config
    );
    console.log({ response });
    const data = await response.data.data;
    setRoles(data);
    setStatus({ loading: false, error: false });
  };

  const getBranches = async () => {
    // try {
    setStatus({ loading: true, error: false });

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusinessId);
    formData.append("business_type", selectedBusiness.business_type_id);


    console.log(formData);

    const response = await axios.post(
      baseUrl() + "businesss/getMyActivationCodeList_staff2",
      formData,
      config
    );
    console.log({ response });

    const data = await response.data.data;

    console.log({ data });
    console.log("branches", data[0]);
    console.log({data});
    setBranches(data[2]);
    setRoles(data[1]);
    setActivatationList(data[0]);
    setStatus({ loading: false, error: false });
    // } catch (error) {
    console.error();
    //   setAlertMsg(error.response.data.message);
    // onShowAlert();
    // }
  };

  const getBranches3 = async () => {
    // try {
    setStatus({ loading: true, error: false });

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusinessId);
    formData.append("business_type", selectedBusiness.business_type_id);


    console.log(formData);

    const response = await axios.post(
      baseUrl() + "businesss/getMyActivationCodeList_staff3",
      formData,
      config
    );
    console.log({ response });

    const data = await response.data.data;

    console.log({ data });
    console.log("branches", data[0]);
    console.log({data});
    setBranches(data[2]);
    setRoles(data[1]);
    setActivatationList(data[0]);
    setStatus({ loading: false, error: false });
    // } catch (error) {
    console.error();
    //   setAlertMsg(error.response.data.message);
    // onShowAlert();
    // }
  };
  console.log({ selectedBusiness });
  useEffect(() => {
    getRoles();
    getBranches();
    getBanklist();
  }, []);

  const onDeleteStaff = (staff) => {
    setOpenDeleteDialog(true);
    setSelectedStaff(staff);
  };

  const handleConfirm = async () => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusinessId);
      formData.append("business_type", selectedBusinessTypeId);
      formData.append("branch_id", selectedStaff.branch_id);
      formData.append("user_id", selectedStaff.user_id);
      const response = await axios.post(
        baseUrl() + "staffs/deleteStaff",
        formData,
        config
      );
      console.log(response);
      const data = await response.data.data;
      console.log(data);
      setStatus({ loading: false, error: false });
      setOpenDeleteDialog(false);
      getBranches();
    } catch (error) {
      console.log(error);
      setStatus({ loading: false, error: true });
    }
  };
  return (
    <IonPage className="pushDown">
      <IonHeader style={{ backgroundColor: "white" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
            {selectedBusinessName && selectedBusinessTypeName && (
              <>
                {selectedBusinessName.toUpperCase()} -{" "}
                {selectedBusinessTypeName}
              </>
            )}{" "}
            - Manage Users
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsModalOpen(true)}
          >
            Add New User
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => history.goBack()}
            style={{ marginLeft: 10 }}
          >
            Go Back
          </Button>
        </Box>
      </IonHeader>

      <IonContent fullscreen className={styles.container}>
        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search by name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {!status.loading ? (
          <StaffsTable
            rows={activatationList.filter((staff) =>
              staff.fullName?.toLowerCase().includes(searchQuery.toLowerCase())
            )}
            roles={roles}
            setOpenModal={setIsModalOpen}
            onDeleteStaff={onDeleteStaff}
            setSelectedStaff={setSelectedStaff}
          />
        ) : (
          <Grid container spacing={1}>
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid item xs={12} sm={12} md={12} key={item}>
                <Card className={styles.skeletonCard}>
                  <CardContent>
                    <Skeleton variant="rectangular" height={30} width="100%" />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        <StaffModal
          branches={branches}
          roles={roles}
          banklist={banklist}
          isOpen={isModalOpen}
          selectedStaff={selectedStaff}
          onClose={() => {
            setIsModalOpen(false), setSelectedStaff(null);
          }}
          onGetactivationList={() => getBranches()}
        />

        <AlertDialog
          open={openDeleteDialog}
          title="Delete Staff?"
          description={`Are you sure you want to remove ${selectedStaff?.fullName}  as a Staff from this business??`}
          onClose={() => setOpenDeleteDialog(false)}
          onConfirm={handleConfirm}
          confirmText="Agree"
          cancelText="Disagree"
        />
      </IonContent>
    </IonPage>
  );
};


export default ManageStaff;
